// To consolidate all ext keywords
export enum MyAccountExtEnum {
  // Core functionality keys
  ENABLE_ALTERNATIVE_NUMBER = 'enableAlternativeNumber',
  USE_ADDRESS_LOOKUP = 'useAddressLookup',
  ADDRESS_BOOK_LIMIT = 'addressBookLimit',
  ADDRESS_BOOK_ALLOW_EDIT_ON_DEFAULT = 'allowEditOnDefault',
  TASK = 'task',
  USE_ACCOUNT_API_FOR_MOBILE = 'useAccountApiForMobile',
  BREADCRUMB_ENABLED = 'breadcrumbEnabled', // To enable breadcrumb in address form (not using single page)
  EDIT_ON_HOME_COUNTRY_ONLY = 'editOnHomeCountryOnly', // To enable edit on home country only

  // Screen level keys
  EDITABLE = 'editable', // is the form editable
  VALIDATION_ON_MOUNT = 'validationOnMount',

  // Input level keys
  CUSTOM_LABEL_KEY = 'customLabelKey', // to customize the label to other translation key
  DISPLAY_AS_INPUT = 'displayAsInput', // readonly field display as input ui (readonly)

  // Address related keys
  HIDE_INPUT_INSTRUCTION = 'hideInputInstruction', // to hide input instruction
  DROPDOWN_DATASOURCE = 'dataSource',
  DEPENDENCY = 'dependency', // dependency field. current field lookup is based on dependency field's value

  VISIBLE_IF = 'visibleIf', // to show/hide field based on value of other field
  DISABLE_IF = 'disableIf', // to disable field based on value of other field
  DISABLE_FIELD_ON_CHECK = 'disableFieldOnCheck', // to disable field if checkbox is checked

  GUIDED_INPUT = 'guidedInput',
  GUIDED_INPUT_SKIP_OPTIONAL_FIELD = 'guidedInput_skipOptionalField',
  ADDRESS_FORMAT = 'addressFormat',
  TYPE = 'type',
  OPTION_FALLBACK_VALUE = 'optionFallbackValue', // to set default value for field

  // For market specific
  DEFAULT_COUNTRY_VALUE = 'defaultCountryValue', // Get country code based on tenant
  COUNTRY_NOT_EDITABLE = 'countryNotEditable',
  HIDE_IF_CONFIRMATION = 'hideIfConfirmation', // This key need to remove in next update, need to update in masterdata first to avoid breaking
  VALID_CITIZENSHIP_COUNTRY = 'validCitizenCountryCode', // To validate citizenship country
  DISPLAY_CITIZENSHIP_COUNTRY_FIELD = 'displayCountryField', // To display citizenship country field
  CO_APP_ENABLE_ADD = 'allowAddCoApp', // To enable add co-applicant
  USE_REGEX_VALIDATION = 'useRegexValidation', // To enable regex validation for phone

  // To remove in next update
  PHONE_HIDE_COUNTRY_CODE = 'hideCountryCode', // Hide country code in phone number
  PHONE_ADD_LEADING_ZERO = 'addLeadingZero', // Add leading zero in phone number

  // For special character handling
  EXCLUDE_CHARS = 'excludeChars', // In Thailand we need to exclude some special characters for count/length validation
  SEARCH_KEY = 'searchKey', // To search key in dropdown

  // For market specific UI adjustment
  UI_REMOVE_BORDER_BOTTOM = 'removeBorderBottom',
  UI_FULL_WIDTH = 'fullWidth',
  UI_HALF_WIDTH = 'halfWidth',
  UI_COLUMNS = 'columns',
}
export enum MyAccountFieldType {
  NONE = '',
  TEXT = 'text',
  GUIDED_INPUT = 'guidedInput',
  PHONE = 'phone',
  DROPDOWN = 'dropdown',
  DATE = 'date',
  PICTURE = 'picture',
  CHECKBOX = 'checkbox',
}

export enum MyAccountFieldName {
  PROFILE_PICTURE = 'profilePic',
  CITIZENSHIP = 'citizenship',
  PHONE = 'phone',
  DIALCODE = 'dialCode',
  EMAIL = 'email',
  BIRTHDATE = 'birthDate',
  MAILING_ADDRESS = 'mailingAddress',
  BILLING_ADDRESS = 'billingAddress',
  TAX_ADDRESS = 'taxAddress',
  TAX_REGIME = 'taxRegime',
  DOCUMENT_TYPE = 'documentType',
  USE_AS_BILLING = 'useAsBilling',
  USE_AS_MAILING = 'useAsMailing',
}

export enum OnSelectSearchEnum {
  CONTAINER = 'Container',
  ADDRESS = 'Address',
  MANUAL = 'IsManual',
  NO_RESULT = 'NoResult',
}
export enum ToastMessageEnum {
  SHIPPING_ADDRESS_VALIDATION_MESSAGE = 'shipping-address-validation-message',
  SHIPPING_ADDRESS_VALIDATION_FAILED = 'shipping-address-validation-failed',
  INFORMATION_SAVED = 'information-saved',
  CONTRACT_SAVED = 'contract-saved',
  SHIPPING_ADDRESS_DELETED_MESSAGE = 'shipping-address-delete-message',
  MARKETING_SETTING_SUCCESS_MESSAGE = 'marketing-setting-success-message',
  MARKETING_SETTING_ERROR_MESSAGE = 'marketing-setting-error-message',
}

export enum ContractEnum {
  SIGNED = 'signed',
  UNSIGN = 'unsign',
}
